import React from 'react';

const PricingTableModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const stage1Pricing = [
    {
      type: 'Single Dwelling',
      total: '$199',
      payment: '$199',
      additionalRevision: 'N/A - Stage 1 has no revisions'
    },
    {
      type: 'Duplex',
      total: '$249',
      payment: '$249',
      additionalRevision: 'N/A'
    },
    {
      type: 'Townhouse (3-5 Units)',
      total: '$499',
      payment: '$499',
      additionalRevision: 'N/A'
    },
    {
      type: 'Townhouse (6-9 Units)',
      total: '$799',
      payment: '$799',
      additionalRevision: 'N/A'
    },
    {
      type: 'Secondary Dwelling',
      total: '$149',
      payment: '$149',
      additionalRevision: 'N/A'
    },
    {
      type: 'Minor Renovation',
      total: '$149',
      payment: '$149',
      additionalRevision: 'N/A'
    },
    {
      type: 'Major Renovation',
      total: '$199',
      payment: '$199',
      additionalRevision: 'N/A'
    }
  ];

  const stage2Pricing = [
    {
      type: 'Single Dwelling',
      variation: '1 Storey',
      total: '$399',
      payments: 'Initial: $150, Final: $249',
      bundled: '$598',
      bundledPayments: 'Initial: $150, Progress: $224, Final: $224',
      includedRevision: '1 included',
      additionalRevision: '$99'
    },
    {
      type: 'Single Dwelling',
      variation: '2 Storeys',
      total: '$550',
      payments: 'Initial: $150, Progress: $200, Final: $200',
      bundled: '$749',
      bundledPayments: 'Initial: $150, Progress: $299.50, Final: $299.50',
      includedRevision: '1 included',
      additionalRevision: '$150'
    },
    {
      type: 'Single Dwelling',
      variation: '3 Storeys',
      total: '$650',
      payments: 'Initial: $150, Progress: $250, Final: $250',
      bundled: '$849',
      bundledPayments: 'Initial: $150, Progress: $349.50, Final: $349.50',
      includedRevision: '1 included',
      additionalRevision: '$150'
    },
    {
      type: 'Duplex',
      variation: '1 Storey',
      total: '$399',
      payments: 'Initial: $150, Final: $249',
      bundled: '$598',
      bundledPayments: 'Initial: $150, Progress: $224, Final: $224',
      includedRevision: '1 included',
      additionalRevision: '$99'
    },
    {
      type: 'Duplex',
      variation: '2 Storeys',
      total: '$550',
      payments: 'Initial: $150, Progress: $200, Final: $200',
      bundled: '$749',
      bundledPayments: 'Initial: $150, Progress: $299.50, Final: $299.50',
      includedRevision: '1 included',
      additionalRevision: '$150'
    },
    {
      type: 'Duplex',
      variation: '3 Storeys',
      total: '$650',
      payments: 'Initial: $150, Progress: $250, Final: $250',
      bundled: '$849',
      bundledPayments: 'Initial: $150, Progress: $349.50, Final: $349.50',
      includedRevision: '1 included',
      additionalRevision: '$150'
    },
    {
      type: 'Townhouse',
      variation: '3-5 Units',
      total: '$799',
      payments: 'Initial: $150, Progress: $324.50, Final: $324.50',
      bundled: '$1,048',
      bundledPayments: 'Initial: $150, Progress: $449, Final: $449',
      includedRevision: '1 included',
      additionalRevision: '$150'
    },
    {
      type: 'Townhouse',
      variation: '6-9 Units',
      total: '$1,099',
      payments: 'Initial: $150, Progress: $474.50, Final: $474.50',
      bundled: '$1,348',
      bundledPayments: 'Initial: $150, Progress: $599, Final: $599',
      includedRevision: '1 included',
      additionalRevision: '$150'
    },
    {
      type: 'Secondary Dwelling',
      variation: 'Standard',
      total: '$299',
      payments: 'Initial: $150, Final: $149',
      bundled: '$448',
      bundledPayments: 'Initial: $150, Final: $298',
      includedRevision: '1 included',
      additionalRevision: '$99'
    },
    {
      type: 'Minor Renovation',
      variation: 'Standard',
      total: '$299',
      payments: 'Initial: $150, Final: $149',
      bundled: '$448',
      bundledPayments: 'Initial: $150, Final: $298',
      includedRevision: '1 included',
      additionalRevision: '$99'
    },
    {
      type: 'Major Renovation',
      variation: '1 Storey',
      total: '$349',
      payments: 'Initial: $150, Final: $199',
      bundled: '$548',
      bundledPayments: 'Initial: $150, Progress: $199, Final: $199',
      includedRevision: '1 included',
      additionalRevision: '$99'
    },
    {
      type: 'Major Renovation',
      variation: '2 Storeys',
      total: '$449',
      payments: 'Initial: $150, Final: $299',
      bundled: '$648',
      bundledPayments: 'Initial: $150, Progress: $249, Final: $249',
      includedRevision: '1 included',
      additionalRevision: '$99'
    }
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl max-w-7xl w-full max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="bg-gradient-to-r from-slate-900 to-blue-700 text-white p-6 flex justify-between items-center">
          <div>
            <h2 className="text-2xl font-bold">Stage 1 & 2 Pricing Structure</h2>
            <p className="text-sm opacity-90 mt-1">Complete pricing and payment breakdown</p>
          </div>
          <button
            onClick={onClose}
            className="text-white hover:bg-white/20 rounded-full p-2 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto p-6">
          {/* Stage 1 Section */}
          <div className="mb-8">
            <h3 className="text-xl font-bold mb-4 text-gray-800 flex items-center">
              <span className="bg-blue-600 text-white px-3 py-1 rounded mr-3">Stage 1</span>
              Desktop Site Investigation & Feasibility
            </h3>
            
            {/* Stage 1 Payment Model Explanation */}
            <div className="bg-green-50 p-4 rounded-lg border border-green-200 mb-4">
              <h4 className="font-semibold text-green-800 mb-2">💳 No Upfront Payment Required</h4>
              <ul className="text-xs text-green-900 space-y-1">
                <li>• Card details captured at project submission — <strong>no charge made</strong></li>
                <li>• Work begins immediately</li>
                <li>• Draft watermarked report delivered within 3-5 business days unless noted or advised otherwise</li>
                <li>• Invoice issued with draft — payment due within 5 days</li>
                <li>• Final unwatermarked report released upon payment</li>
                <li>• <strong>Auto-charge:</strong> Card automatically charged if invoice unpaid after 5 days — final unwatermarked report released once payment is processed</li>
              </ul>
            </div>

            <div className="bg-white shadow-lg rounded-lg overflow-hidden">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700">Project Type</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700">Total Cost</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700">
                      Payment
                      <div className="text-[10px] font-normal text-gray-500">(on delivery)</div>
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700">Revisions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {stage1Pricing.map((row, idx) => (
                    <tr key={idx} className="hover:bg-gray-50">
                      <td className="px-4 py-3 text-xs font-medium text-gray-900">{row.type}</td>
                      <td className="px-4 py-3 text-xs font-bold text-green-600">{row.total}</td>
                      <td className="px-4 py-3 text-xs text-gray-600">{row.payment}</td>
                      <td className="px-4 py-3 text-xs text-gray-500">{row.additionalRevision}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
            {/* Stage 1 Notes */}
            <div className="mt-3 text-xs text-gray-600 bg-blue-50 p-3 rounded">
              <p>💡 <strong>Note:</strong> Stage 1 Desktop Site Investigation & Feasibility reports do not include revisions. 
              The report provides comprehensive desktop analysis of your site's development potential.</p>
            </div>
          </div>

          {/* Stage 2 Section */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-gray-800 flex items-center">
              <span className="bg-green-600 text-white px-3 py-1 rounded mr-3">Stage 2</span>
              Concept Design
            </h3>
            <div className="bg-white shadow-lg rounded-lg overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full min-w-[800px]">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700" rowSpan="2">Project Type</th>
                      <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700" rowSpan="2">Variation</th>
                      <th className="px-4 py-3 text-center text-xs font-semibold text-gray-700 border-l" colSpan="2">
                        Stage 2 Only
                        <div className="text-[10px] font-normal text-gray-500 mt-0.5">
                          (If Stage 1 completed)
                        </div>
                      </th>
                      <th className="px-4 py-3 text-center text-xs font-semibold text-gray-700 border-l" colSpan="2">
                        Bundled
                        <div className="text-[10px] font-normal text-gray-500 mt-0.5">
                          (If Stage 1 bypassed - includes integrated site investigation)
                        </div>
                      </th>
                      <th className="px-4 py-3 text-center text-xs font-semibold text-gray-700 border-l" colSpan="2">
                        Revisions
                      </th>
                    </tr>
                    <tr className="bg-gray-50">
                      <th className="px-4 py-2 text-left text-[10px] font-semibold text-gray-600 border-l">Total</th>
                      <th className="px-4 py-2 text-left text-[10px] font-semibold text-gray-600">Payments</th>
                      <th className="px-4 py-2 text-left text-[10px] font-semibold text-gray-600 border-l">Total</th>
                      <th className="px-4 py-2 text-left text-[10px] font-semibold text-gray-600">Payments</th>
                      <th className="px-4 py-2 text-left text-[10px] font-semibold text-gray-600 border-l">Included</th>
                      <th className="px-4 py-2 text-left text-[10px] font-semibold text-gray-600">
                        Additional
                        <div className="text-[9px] font-normal">
                          (per revision)
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {stage2Pricing.map((row, idx) => (
                      <tr key={idx} className="hover:bg-gray-50">
                        <td className="px-4 py-3 text-xs font-medium text-gray-900">{row.type}</td>
                        <td className="px-4 py-3 text-xs text-gray-600">{row.variation}</td>
                        <td className="px-4 py-3 text-xs font-bold text-green-600 border-l">{row.total}</td>
                        <td className="px-4 py-3 text-[10px] text-gray-600">{row.payments}</td>
                        <td className="px-4 py-3 text-xs font-bold text-blue-600 border-l">{row.bundled}</td>
                        <td className="px-4 py-3 text-[10px] text-gray-600">{row.bundledPayments}</td>
                        <td className="px-4 py-3 text-xs text-gray-600 border-l">{row.includedRevision}</td>
                        <td className="px-4 py-3 text-xs font-semibold text-orange-600">{row.additionalRevision}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Info boxes */}
            <div className="grid md:grid-cols-2 gap-4 mt-4">
              <div className="bg-green-50 p-4 rounded-lg">
                <h4 className="font-semibold text-green-800 mb-2 text-xs">💰 Payment Structure - Stage 2</h4>
                <ul className="text-xs text-gray-700 space-y-1">
                  <li className="font-semibold text-green-900">• Initial payment required before project commencement</li>
                  <li className="font-semibold text-green-900">• Progress/final payments required before deliverables are released</li>
                </ul>
              </div>
              <div className="bg-orange-50 p-4 rounded-lg">
                <h4 className="font-semibold text-orange-800 mb-2 text-xs">🔄 Revision Policy</h4>
                <ul className="text-xs text-gray-700 space-y-1">
                  <li>• All Stage 2 projects include 1 revision round</li>
                  <li>• Additional revisions charged per revision as per table</li>
                  <li className="font-semibold text-orange-900">• Payment required before additional revision work begins</li>
                </ul>
              </div>
            </div>

            {/* Professional Services Footer */}
            <div className="bg-gray-50 p-4 border-t mt-6">
              <p className="text-xs text-center text-gray-700 font-semibold mb-1">
                All services delivered through our online platform by qualified professionals
              </p>
              <p className="text-[10px] text-center text-gray-500">
                Complex sites and briefs may require additional consultation at planAIdesign's discretion
              </p>
              <p className="text-[10px] text-center text-gray-500">
                This service does not include preliminary costings. If required, we recommend engaging a qualified Quantity Surveyor (QS).
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingTableModal;